import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { PopoverCloseElementProps, PopoverElementProps, PopoverGripElementProps } from './types';

const fade_in = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const PopoverElement = styled.form<PopoverElementProps>`
  font-family: ${({ theme }) => theme.general.font_family};
  font-size: ${({ theme }) => theme.general.font_size};
  backdrop-filter: ${({ theme }) => theme.general.backdrop_filter};
  border-radius: ${({ theme }) => theme.general.border_radius};
  padding: ${({ theme }) => theme.general.padding};
  background: ${({ theme }) => theme.background.normal};
  border: ${({ theme }) => theme.border.normal};
  right: ${({ right }) => right};
  visibility: ${({ is_visible }) => (is_visible ? 'visible' : 'hidden')};
  animation: ${fade_in} ${({ duration }) => duration}ms ease;
  opacity: ${({ is_visible }) => (is_visible ? 1 : 0)};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  gap: ${({ gap }) => gap};
`;

export const PopoverGripElement = styled.div<PopoverGripElementProps>`
  color: ${({ theme }) => theme.color.normal};

  &:hover {
    color: ${({ theme }) => theme.color.hover};
  }

  &:active {
    color: ${({ theme }) => theme.color.active};
  }
`;

export const PopoverCloseElement = styled.div<PopoverCloseElementProps>`
  color: ${({ theme }) => theme.color.normal};

  &:hover {
    color: ${({ theme }) => theme.color.hover};
  }

  &:active {
    color: ${({ theme }) => theme.color.active};
  }
`;
